/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamDropInRequestBookingId } from './oralExamDropInRequestBookingId';
import type { OralExamDropInRequestRung } from './oralExamDropInRequestRung';

/**
 * Body for lecturer drop-in to a student room or step back to console.
 */
export interface OralExamDropInRequest {
  bookingId?: OralExamDropInRequestBookingId;
  rung?: OralExamDropInRequestRung;
}
